var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffeeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M649.2 341.6l-24.8-70.3H392.6l-24.8 70.3M649.2 411.9l-50.4 337.7H418.1l-50.3-337.7",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.5 341.6H332.6l7 70.3h337.8l7-70.3z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628 651.2H389l-21.2-154.7h281.4z",
    fill: "#F4867B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.8 332.2c-2.7-2.9-6.5-4.6-10.4-4.6h-25.2l-21.5-61c-2-5.6-7.3-9.4-13.3-9.4H392.6c-6 0-11.3 3.8-13.3 9.4l-21.5 61h-25.2c-4 0-7.8 1.7-10.4 4.6-2.7 2.9-4 6.9-3.6 10.8l6.9 70.3c0.7 7.2 6.8 12.7 14 12.7h16.1l8.5 56.9c-2.7 0.7-5.1 2.2-7 4.3-2.7 3.1-3.9 7.1-3.3 11.2L375 653.1c1 7 6.9 12.2 13.9 12.2h2.4l12.9 86.4c1 6.9 7 12 13.9 12h180.7c7 0 12.9-5.1 13.9-12l12.9-86.4h2.4c7 0 13-5.2 13.9-12.2l21.2-154.8c0.6-4-0.7-8.1-3.3-11.2-1.9-2.1-4.3-3.6-7-4.3l8.5-56.9h16.1c7.2 0 13.3-5.5 14-12.7l6.9-70.3c0.5-3.9-0.8-7.8-3.5-10.7z m-173.4-46.9c-0.3 3.6-1.3 7.8-3.7 10.5-2.1 2.4-5.2 3.5-9.6 3.5-4.4 0-7.7-1.2-10.1-3.7-2.5-2.7-3.8-6.8-4.3-10.3h27.7z m-118.9 0h77c0.6 5.8 2.5 13.7 8.1 19.8 5 5.4 12.1 8.3 20.4 8.3 10.6 0 16.9-4.6 20.2-8.4 5.3-6.1 6.8-13.9 7.2-19.7h79l14.9 42.2H387.7l14.8-42.2z m184.2 450.2H430.3l-10.5-70.3h177.4l-10.5 70.3z m29-98.4H401.3L384 510.5h249.1l-17.4 126.6z m8.8-154.7h-232l-8.4-56.4h248.7l-8.3 56.4z m40.2-84.5H352.3l-4.2-42.2h320.6l-4 42.2z",
    fill: "#211F1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeIcon);
export default __webpack_public_path__ + "static/media/CoffeeIcon.48c7ff8c14e8be2ddbe285e1f3e75d3b.svg";
export { ForwardRef as ReactComponent };